import * as Headless from '@headlessui/react'
import { Link as RouterLink } from 'react-router-dom'
import { forwardRef } from 'react'

export const Link = forwardRef(function Link({ href, ...props }, ref) {
  // Handle anchor links for smooth scrolling
  if (href && href.startsWith('#')) {
    const handleClick = (e) => {
      e.preventDefault()
      const element = document.querySelector(href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
      if (props.onClick) {
        props.onClick(e)
      }
    }
    
    return (
      <Headless.DataInteractive>
        <a ref={ref} href={href} {...props} onClick={handleClick} />
      </Headless.DataInteractive>
    )
  }
  
  return (
    <Headless.DataInteractive>
      <RouterLink ref={ref} to={href} {...props} />
    </Headless.DataInteractive>
  )
})
